import { notifications } from '@mantine/notifications';
import { ReactNode } from 'react';

type AlertOptions = {
  autoClose?: number | false;
};

// when passing one parameter, consider it as the message and use the default title
type AlertInput = string | { message: string | ReactNode; title?: string; options?: AlertOptions };

function error(input: AlertInput): string {
  const title = typeof input === 'string' ? 'Error' : input.title;
  const message = typeof input === 'string' ? input : input.message;

  return notifications.show({
    title,
    message,
    color: 'red',
    ...(typeof input !== 'string' && input.options),
  });
}

function info(input: AlertInput): string {
  const title = typeof input === 'string' ? 'Info' : input.title;
  const message = typeof input === 'string' ? input : input.message;

  return notifications.show({
    title,
    message,
    color: 'blue',
    ...(typeof input !== 'string' && input.options),
  });
}

function warning(input: AlertInput): string {
  const title = typeof input === 'string' ? 'Warning' : input.title;
  const message = typeof input === 'string' ? input : input.message;

  return notifications.show({
    title,
    message,
    color: 'yellow',
    ...(typeof input !== 'string' && input.options),
  });
}

function success(input: AlertInput): string {
  const title = typeof input === 'string' ? 'Success' : input.title;
  const message = typeof input === 'string' ? input : input.message;

  return notifications.show({
    title,
    message,
    color: 'green',
    ...(typeof input !== 'string' && input.options),
  });
}

/** Dismiss a previously shown alert by the id the show functions return. */
function hide(id: string): void {
  notifications.hide(id);
}

export const alert = {
  hide,
  error,
  info,
  warning,
  success,
};
